module.exports = __webpack_public_path__ + "static/media/Yenepoya Photos-4.35a65134.png";